import Vue from 'vue'
import Router from 'vue-router'
import store from '../utils/store'
const requireComponent = require.context("@/views", true, /routes\.js$/);
let routes = [];
requireComponent.keys().forEach(filePath => {
  const componentConfig = requireComponent(filePath);
  routes = [...routes, ...componentConfig.default]
});

Vue.use(Router)
const myComponents = {
  Launch: r => require.ensure([], () => r(require('@/components/home/Launch')), 'com-launch'),
  Home: r => require.ensure([], () => r(require('@/components/home/Home.vue')), 'com-index'),
  Account: r => require.ensure([], () => r(require('@/components/account/Account')), 'com-account'),
  AccountEmpty: r => require.ensure([], () => r(require('@/components/account/AccountEmpty')), 'com-account-empty'),
  Advance: r => require.ensure([], () => r(require('@/components/advance/Advance')), 'com-advance'),
  AdvanceRecord: r => require.ensure([], () => r(require('@/components/advance/AdvanceRecord')), 'com-advance-record'),
  My: r => require.ensure([], () => r(require('@/components/my/My')), 'com-my'),
  Login: r => require.ensure([], () => r(require('@/components/login/Login')), 'com-login'),
  BindAlipay: r => require.ensure([], () => r(require('@/components/alipay/BindAlipay')), 'com-bind-alipay'),
  SlowBank: r => require.ensure([], () => r(require('@/components/card/slowBank')), 'com-slow-bank'),
  Detailed: r => require.ensure([], () => r(require('@/components/account/Detailed')), 'com-detailed'),
  AccountDetails: r => require.ensure([], () => r(require('@/components/account/AccountDetails')), 'com-account-details'),
  Card: r => require.ensure([], () => r(require('@/components/card/Card')), 'com-card'),
  BindCard: r => require.ensure([], () => r(require('@/components/card/bindCard')), 'com-bind-card'),
  LoginVertify: r => require.ensure([], () => r(require('@/components/login/LoginVertify')), 'com-vertify-login'),
  Serve: r => require.ensure([], () => r(require('@/components/my/Serve')), 'com-bind-serve'),
  Apply: r => require.ensure([], () => r(require('@/components/advance/Apply')), 'com-apply'),
  ApplySure: r => require.ensure([], () => r(require('@/components/advance/ApplySure')), 'com-sure'),
  ApplySuccess: r => require.ensure([], () => r(require('@/components/advance/ApplySuccess')), 'com-success'),
  About: r => require.ensure([], () => r(require('@/components/my/about')), 'com-about'),
  BindAll: r => require.ensure([], () => r(require('@/components/bind/bindAll')), 'com-bind-all'),
  CardDetail: r => require.ensure([], () => r(require('@/components/card/CardDetail')), 'com-card-detail'),
  AgreementList: r => require.ensure([], () => r(require('@/components/cash/AgreementList')), 'com-cash-agreement-list'),
  Daily: r => require.ensure([], () => r(require('@/components/daily/daily')), 'com-daily'),
  DailyRecord: r => require.ensure([], () => r(require('@/components/daily/dailyRecord')), 'com-daily-record'),
  DailyCalendar: r => require.ensure([], () => r(require('@/components/daily/dailyCalendar')), 'com-daily-calendar'),
  DailySignCalendar: r => require.ensure([], () => r(require('@/components/daily/dailySignCalendar')), 'com-daily-calendar'),
  DailyFail: r => require.ensure([], () => r(require('@/components/daily/fail')), 'com-daily-fail'),
  WageSlip: r => require.ensure([], () => r(require('@/components/my/wageSlip')), 'com-wage-slip'),
  Help: r => require.ensure([], () => r(require('@/components/my/help')), 'com-help'),
  HelpNew: r => require.ensure([], () => r(require('@/components/my/helpNew')), 'com-help-new'),
  HelpDetail: r => require.ensure([], () => r(require('@/components/my/helpDetail')), 'com-help-detail'),
  PersonInfo: r => require.ensure([], () => r(require('@/components/my/personInfo')), 'com-person-info'), //个人信息
  MyCompany: r => require.ensure([], () => r(require('@/components/my/myCompany')), 'com-my-company'), //我的企业
  Setting: r => require.ensure([], () => r(require('@/components/my/setting')), 'com-setting'), //设置
  Announcement: r => require.ensure([], () => r(require('@/components/corporateServices/announcement')), 'com-announcement'), //公共
  AnnouncementDetail: r => require.ensure([], () => r(require('@/components/corporateServices/announcementDetail')), 'com-announcement-detail'), //公共
  commitInfo: r => require.ensure([], () => r(require('@/components/entry/commitInfo')), 'com-commit-info'),
  download: r => require.ensure([], () => r(require('@/components/entry/download')), 'com-download'),
  empty: r => require.ensure([], () => r(require('@/components/entry/empty')), 'com-empty'),
  SetNews: r => require.ensure([], () => r(require('@/components/my/setNews')), 'com-set-news'),
  Credential: r => require.ensure([], () => r(require('@/components/credential/index')), 'com-credential'),
  ValidatePhoto: r => require.ensure([], () => r(require('@/components/daily/validatePhoto')), 'com-validate-photo'),
  ValidateNewPhoto: r => require.ensure([], () => r(require('@/components/daily/validateNewPhoto')), 'com-validate-new-photo'),
  Appeal: r => require.ensure([], () => r(require('@/components/appeal')), 'com-appeal'), // 申诉页

  MyContract: r => require.ensure([], () => r(require('@/components/econtract/myContract')), 'com-my-contract'),
  GainContract: r => require.ensure([], () => r(require('@/components/econtract/gainContract')), 'com-gain-contract'),
  WriteContract: r => require.ensure([], () => r(require('@/components/econtract/writeContract')), 'com-write-contract'),
  NextStep: r => require.ensure([], () => r(require('@/components/econtract/nextStep')), 'com-next-step-contract'),
  Identification: r => require.ensure([], () => r(require('@/components/econtract/identification')), 'com-identification-contract'),
  Viewpdf: r => require.ensure([], () => r(require('@/components/viewpdf/Index')), 'com-viewpdf'),
  PersonalSign: r => require.ensure([], () => r(require('@/components/personalsign/Index')), 'com-personalsign'),
  Pdf: r => require.ensure([], () => r(require('@/components/pdf/Index')), 'com-pdf'),

  EmployeeDetail: r => require.ensure([], () => r(require('@/components/employeeDetail/Index')), 'com-employee'),
};
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default new Router({
  routes: [{
    path: '/',
    name: 'launch',
    component: myComponents.Launch
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/my',
    component: myComponents.Home,
    children: [{
      path: '/account',
      name: 'account',
      component: myComponents.Account,
      meta: {
        title: '可领取收入',
        keepAlive: true,
      }
    },
    {
      path: '/advance',
      name: 'advance',
      component: myComponents.Advance,
      meta: {
        title: '预支',
        keepAlive: false,
      }
    },
    {
      path: '/daily',
      name: 'daily',
      component: myComponents.Daily,
      meta: {
        title: '打卡',
        keepAlive: true,
      }
    },
    {
      path: '/validatePhoto',
      name: 'validatePhoto',
      component: myComponents.ValidatePhoto,
      meta: {
        title: '提交信息',
        keepAlive: true,
      }
    },
    {
      path: '/validateNewPhoto',
      name: 'validateNewPhoto',
      component: myComponents.ValidateNewPhoto,
      meta: {
        title: '提交信息',
        keepAlive: false,
      }
    },
    {
      path: '/my',
      name: 'my',
      component: myComponents.My,
      meta: {
        title: '我的',
        keepAlive: true,
      }
    }
    ]
  },
  {
    path: '/agreementList',
    name: 'agreementList',
    component: myComponents.AgreementList,
    meta: {
      title: '协议',
      keepAlive: true,
    }
  },
  {
    path: '/bindAlipay',
    name: 'bindAlipay',
    component: myComponents.BindAlipay,
    meta: {
      title: '绑定支付宝',
      keepAlive: true,
    }
  },
  {
    path: '/detailed',
    name: 'detailed',
    component: myComponents.Detailed,
    meta: {
      title: '收支明细',
      keepAlive: true,
    }
  },
  {
    path: '/accountDetails/:customerId/:merchantName',
    name: 'accountDetails',
    component: myComponents.AccountDetails,
    meta: {
      title: '收支明细',
      keepAlive: true,
    }
  },
  {
    path: '/accountEmpty',
    name: 'accountEmpty',
    component: myComponents.AccountEmpty,
    meta: {
      title: '收支明细',
      keepAlive: true,
    }
  },
  {
    path: '/card',
    name: 'card',
    component: myComponents.Card,
    meta: {
      title: '我的银行卡',
      keepAlive: true,
    }
  },
  {
    path: '/cardDetail',
    name: 'cardDetail',
    component: myComponents.CardDetail,
    meta: {
      title: '银行卡管理',
      keepAlive: true,
    }
  },
  {
    path: '/bindCard',
    name: 'bindCard',
    component: myComponents.BindCard,
    meta: {
      title: '我的银行卡',
      keepAlive: true,
    }
  },
  {
    path: '/serve',
    name: 'serve',
    component: myComponents.Serve,
    meta: {
      title: '联系客服',
      keepAlive: true,
    }
  },
  // {
  //   path: '/wageSlip',
  //   name: 'wageSlip',
  //   component: myComponents.WageSlip,
  //   meta: {
  //     title: '我的工资单',
  //     keepAlive: true,
  //   }
  // },
  {
    path: '/apply/:acount',
    name: 'apply',
    component: myComponents.Apply,
    meta: {
      title: '预支',
      keepAlive: true,
    }
  },
  {
    path: '/advanceRecord',
    name: 'advanceRecord',
    component: myComponents.AdvanceRecord,
    meta: {
      title: '预支记录',
      keepAlive: true,
    }
  },
  {
    path: '/sure',
    name: 'sure',
    component: myComponents.ApplySure,
    meta: {
      title: '预支',
      keepAlive: true,
    }
  },
  {
    path: '/applySuccess',
    name: 'applySuccess',
    component: myComponents.ApplySuccess,
    meta: {
      title: '预支',
      keepAlive: true,
    }
  },
  {
    path: '/login',
    name: 'login',
    component: myComponents.Login,
    meta: {
      title: '登录',
      keepAlive: true,
    }
  },
  {
    path: '/vertify',
    name: 'vertify',
    component: myComponents.LoginVertify,
    meta: {
      title: '登录',
      keepAlive: true,
    }
  },
  {
    path: '/about',
    name: 'about',
    component: myComponents.About,
    meta: {
      title: '关于我们',
      keepAlive: true,
    }
  },
  {
    path: '/help',
    name: 'help',
    component: myComponents.Help,
    meta: {
      title: '帮助中心',
      keepAlive: true,
    }
  },
  {
    path: '/helpNew',
    name: 'helpNew',
    component: myComponents.HelpNew,
    meta: {
      title: '帮助中心',
      keepAlive: true,
    }
  },
  {
    path: '/helpDetail/:type',
    name: 'helpDetail',
    component: myComponents.HelpDetail,
    meta: {
      title: '帮助中心',
      keepAlive: true,
    }
  },
  {
    path: '/personInfo',
    name: 'personInfo',
    component: myComponents.PersonInfo,
    meta: {
      title: '个人信息',
      keepAlive: true,
    }
  },
  {
    path: '/myCompany',
    name: 'myCompany',
    component: myComponents.MyCompany,
    meta: {
      title: '切换企业',
      keepAlive: true,
    }
  },
  {
    path: '/setting',
    name: 'setting',
    component: myComponents.Setting,
    meta: {
      title: '设置',
      keepAlive: true,
    }
  },
  {
    path: '/setNews',
    name: 'setNews',
    component: myComponents.SetNews,
    meta: {
      title: '消息通知设置',
      keepAlive: true,
    }
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: myComponents.Announcement,
    meta: {
      title: '公告',
      keepAlive: true,
    }
  },
  {
    path: '/announcement/detail/:noticeNo/:merchantNo',
    name: 'detail',
    component: myComponents.AnnouncementDetail,
    meta: {
      title: '公告',
      keepAlive: true,
    }
  },

  {
    path: '/bindAll',
    name: 'bindAll',
    component: myComponents.BindAll,
    meta: {
      title: '绑定提现渠道',
      keepAlive: true,
    }
  },
  {
    path: '/slowBank',
    name: 'slowBank',
    component: myComponents.SlowBank,
    meta: {
      title: '温馨提示',
      keepAlive: true,
    }
  },
  {
    path: '/dailyRecord',
    name: 'dailyRecord',
    component: myComponents.DailyRecord,
    meta: {
      title: '打卡',
      keepAlive: true,
    }
  },
  {
    path: '/dailyCalendar',
    name: 'dailyCalendar',
    component: myComponents.DailyCalendar,
    meta: {
      title: '记录',
      keepAlive: true,
    }
  },
  {
    path: '/dailySignCalendar/:cdate',
    name: 'DailySignCalendar',
    component: myComponents.DailySignCalendar,
    meta: {
      title: '打卡发薪记录',
      keepAlive: true,
    }

  },
  {
    path: '/dailyFail',
    name: 'DailyFail',
    component: myComponents.DailyFail,
    meta: {
      title: '补卡',
      keepAlive: true,
    }
  },
  {
    path: '/commitInfo',
    name: 'commitInfo',
    component: myComponents.commitInfo,
    meta: {
      title: '提交信息',
      keepAlive: true,
    }
  },
  {
    path: '/empty',
    name: 'empty',
    component: myComponents.empty,
    meta: {
      title: '提交信息',
      keepAlive: true,
    }
  },
  {
    path: '/download',
    name: 'download',
    component: myComponents.download,
    meta: {
      title: '下载',
      keepAlive: true,
    }
  },
  {
    path: '/credential',
    name: 'credential',
    component: myComponents.Credential,
    meta: {
      title: '员工信息',
      keepAlive: true,
    }
  },
  // 开发环境 访问链接 employeeDetail?entryManagementId=100001864
  // 测试环境 访问链接 employeeDetail?entryManagementId=10004888
  {
    path: '/employeeDetail',
    name: 'employeeDetail',
    component: myComponents.EmployeeDetail,
    meta: {
      title: '员工详情',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/appeal/:appealBizNo/:riskBizNo',
    name: 'Appeal',
    component: myComponents.Appeal,
    meta: {
      title: '申诉',
      keepAlive: true, //此组件不需要被缓存
    }
  },
  {
    path: '/myContract',
    name: 'myContract',
    component: myComponents.MyContract,
    beforeEnter(to, from, next) {
      if (to.path === '/myContract' || from.path === '/writeContract') {
        store.commit('SET_CASE', false);
        sessionStorage.removeItem('list')
      } else {
        store.commit('SET_CASE', false)
        sessionStorage.removeItem('list')
      }
      next()
    },
    meta: {
      title: '劳动合同',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/gainContract',
    name: 'gainContract',
    component: myComponents.GainContract,
    meta: {
      title: '获取合同',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/writeContract',
    name: 'writeContract',
    component: myComponents.WriteContract,
    beforeEnter(to, from, next) {
      if (from.path === '/myContract' || to.path === '/writeContract') {
        store.commit('SET_CASE', true)
      } else {
        store.commit('SET_CASE', false)
      }
      next()
    },
    meta: {
      title: '电子合同',
      keepAlive: true,
    }
  },
  {
    path: '/nextStep',
    name: 'nextStep',
    component: myComponents.NextStep,
    meta: {
      title: '电子合同',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/identification',
    name: 'identification',
    component: myComponents.Identification,
    meta: {
      title: '认证身份',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/viewpdf',
    name: 'viewpdf',
    component: myComponents.Viewpdf,
    meta: {
      title: '查看合同',
      keepAlive: false,
    }
  },
  {
    path: '/personalSign',
    name: 'personalsign',
    component: myComponents.PersonalSign,
    meta: {
      title: '签署中',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: myComponents.Pdf,
    meta: {
      title: '签署中',
      keepAlive: false, //此组件不需要被缓存
    }
  },
  ...routes,
  {
    path: '*',
    redirect: '/account'
  }
  ]
})
